import { createRouter, createWebHistory, createWebHashHistory } from "vue-router";
import SignIn from "@/views/pages/sign-in.vue";

import { isAuth } from "@/utils";
import AdminDashboard from "@/views/pages/dashboard/admin-dashboard.vue";
import UsersList from "@/views/pages/users/users-list.vue";
import DevotionPage from "@/views/pages/devotion/devotion-page.vue";
import WordOfDay from "@/views/pages/devotion/word-of-day.vue";
import DailyVerse from "@/views/pages/dailyVerse/daily-verse.vue";
import AddEditDailyVerse from "@/views/pages/dailyVerse/add-edit-daily-verse.vue";
import AddEditDevotion from "@/views/pages/devotion/add-edit-devotion.vue";
import ViewCategories from "@/views/pages/devotion/devotion-categories-page";
import PodcastPage from "@/views/pages/podcast/podcast-page.vue";
import AddEditPodcast from "@/views/pages/podcast/add-edit-podcast";
import ViewPodcastCategories from "@/views/pages/podcast/podcast-categories";
import DevotionInfo from "@/views/pages/devotion/devotion-info.vue";
import PlanPage from "@/views/pages/plans/plan-page.vue";
import SubscriptionPage from "@/views/pages/subscriptions/subscription-page.vue";
import Error404 from "@/views/pages/error/error-404.vue";
import UpdatePage from "@/views/pages/updates/update-page.vue";
import Donations from "@/views/pages/donation/donations.vue";
import MediaPage from "@/views/pages/mediaLibrary/media-page.vue";
import SplashScreenPage from "@/views/pages/splashScreen/splash-screen.vue";
import ChatGroupPage from "@/views/pages/chatGroup/chat-groups.vue";
import SupportContactPage from "@/views/pages/support/support-contacts.vue";
import CampaignList from "@/views/pages/Campaign/campaign-list.vue";
import AddCampaign from "@/views/pages/Campaign/add-campaign.vue";
import EditCampaign from "@/views/pages/Campaign/edit-campaign.vue";

const routes = [
  {
    path: "/",
    name: "sign-in",

    meta: {
      requiresAuth: false,
      permissionsRequired: [],
    },
    component: SignIn,
  },
  {
    path: "/dashboard",
    name: "dashboard",

    meta: {
      requiresAuth: true,
      permissionsRequired: [],
    },
    component: AdminDashboard,
  },

    {
        path: "/media/management",
        name: "media",

        meta: {
            requiresAuth: true,
            permissionsRequired: [],
        },
        component: MediaPage,
    },
    {
        path: "/splash/screen",
        name: "splash-screen",

        meta: {
            requiresAuth: true,
            permissionsRequired: [],
        },
        component: SplashScreenPage,
    },

    {
        path: "/chat/groups",
        name: "chat-groups",

        meta: {
            requiresAuth: true,
            permissionsRequired: [],
        },
        component: ChatGroupPage,
    },

  {
    path: "/devotional",
    name: "devotion",

    meta: {
      requiresAuth: true,
      permissionsRequired: [],
    },
    children: [
      {
        path: "",
        name: "devotion-list",

        meta: {
          requiresAuth: true,
          permissionsRequired: [],
        },
        component: DevotionPage,
      },
      {
        path: "view/:encodedData",
        name: "view-devotion",

        meta: {
          requiresAuth: true,
          permissionsRequired: [],
        },
        component: DevotionInfo,
      },
      {
        path: ":action/:encodedData",
        name: "add-edit-devotion",

        meta: {
          requiresAuth: true,
          permissionsRequired: [],
        },
        component: AddEditDevotion,
      },
      {
        path: "categories",
        name: "view-categories",

        meta: {
          requiresAuth: true,
          permissionsRequired: [],
        },
        component: ViewCategories,
      },
      {
        path: "word-of-day",
        name: "word-of-day",

        meta: {
          requiresAuth: true,
          permissionsRequired: [],
        },
        component: WordOfDay,
      },
    ],
  },

    {
        path: "/podcast",
        name: "podcast",

        meta: {
            requiresAuth: true,
            permissionsRequired: [],
        },
        children: [
            {
                path: "",
                name: "podcast-list",

                meta: {
                    requiresAuth: true,
                    permissionsRequired: [],
                },
                component: PodcastPage,
            },
            {
                path: ":action/:encodedData?",
                name: "add-edit-podcast",

                meta: {
                    requiresAuth: true,
                    permissionsRequired: [],
                },
                component: AddEditPodcast,
            },
            {
                path: "categories",
                name: "view-podcast-categories",

                meta: {
                    requiresAuth: true,
                    permissionsRequired: [],
                },
                component: ViewPodcastCategories,
            },

        ],
    },

    {
        path: "/campaigns",
        name: "campaign",

        meta: {
            requiresAuth: true,
            permissionsRequired: []
        },
        children: [
            {
                path: "",
                name: "campaign-list",
                meta: {
                    requiresAuth: true,
                    permissionsRequired: []
                },
                component: CampaignList
            },
            {
                path: "add",
                name: "add-campaign",
                meta: {
                    requiresAuth: true,
                    permissionsRequired: []
                },
                component: AddCampaign
            },
            {
                path: "edit/:encodedData?",
                name: "edit-campaign",
                meta: {
                    requiresAuth: true,
                    permissionsRequired: []
                },
                component: EditCampaign
            },
        ]
    },

    {
        path: "/dailyVerse",
        name: "dailyVerse",

        meta: {
            requiresAuth: true,
            permissionsRequired: [],
        },
        children: [
            {
                path: "",
                name: "verse-list",

                meta: {
                    requiresAuth: true,
                    permissionsRequired: [],
                },
                component: DailyVerse,
            },
            {
                path: ":action/:encodedData",
                name: "add-edit-daily-verse",

                meta: {
                    requiresAuth: true,
                    permissionsRequired: [],
                },
                component: AddEditDailyVerse,
            },

        ],
    },

  {
    path: "/users",
    name: "users",

    meta: {
      requiresAuth: true,
      permissionsRequired: [],
    },
    children: [
      {
        path: "",
        name: "users",

        meta: {
          requiresAuth: true,
          permissionsRequired: [],
        },
        component: UsersList,
      },
    ],
  },
    {
        path: "/support/contacts",
        name: "support-contacts",

        meta: {
            requiresAuth: true,
            permissionsRequired: [],
        },
        component: SupportContactPage,
    },
  {
    path: "/plans",
    name: "plans",

    meta: {
      requiresAuth: true,
      permissionsRequired: [],
    },
    component: PlanPage,
  },
  {
    path: "/subscriptions",
    name: "subscriptions",

    meta: {
      requiresAuth: true,
      permissionsRequired: [],
    },
    component: SubscriptionPage,
  },
  {
    path: "/donations",
    name: "donations",

    meta: {
      requiresAuth: true,
      permissionsRequired: [],
    },
    component: Donations,
  },
  {
    path: "/update",
    name: "updates",

    meta: {
      requiresAuth: true,
      permissionsRequired: [],
    },
    component: UpdatePage,
  },
  {
    path: "/:catchAll(.*)",
    component: Error404,
    meta: {
      requiresAuth: true,
      permissionsRequired: [],
    },
  },
];

export const router = createRouter({
  history: createWebHistory("/"),
  linkActiveClass: "active",
  routes,
});

// export const router = createRouter({
//   history: createWebHashHistory(), // <- Hash mode avoids refresh issues
//   linkActiveClass: "active",
//   routes,
// });

/**
 *
 * @param {import("vue-router").RouteLocationNormalized} route
 */
const middleware = (route) => {
  let result = { toLogin: false, canContinue: true };
  if (route.meta.requiresAuth) {
    if (isAuth()) {
      result.canContinue = true;
    } else {
      result.toLogin = true;
      result.canContinue = false;
    }
  }
  return result;
};

router.beforeEach((to, from, next) => {
  const { toLogin, canContinue } = middleware(to);
  if (canContinue) {
    next();
  } else if (toLogin) {
    next("?next=" + to.path);
  }
  window.scrollTo({ top: 0, behavior: "smooth" });
});
